export enum UserRole {
  User = 'user',
  Admin = 'admin',
  Analyst = 'analyst',
  ProductionEngineer = 'production-engineer',
  FieldSpecialist = 'field-specialist',
}
